import React, { SVGProps } from 'react';

const PendingIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			width="100%"
			height="100%"
			viewBox="0 0 14 12"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2.00815 5.68465C2.17213 2.518 4.79141 0 8 0C11.3144 0 14 2.68682 14 6C14 9.31318 11.3144 12 8 12C5.79256 12 3.86426 10.8074 2.82338 9.03388C2.68361 8.79572 2.76337 8.48935 3.00153 8.34958C3.23969 8.20981 3.54606 8.28957 3.68583 8.52772C4.55455 10.008 6.16165 11 8 11C10.762 11 13 8.76102 13 6C13 3.23898 10.762 1 8 1C5.23801 1 3 3.23898 3 6V6.18388L5.20785 4.59423C5.43195 4.43288 5.74442 4.48375 5.90577 4.70785C6.06712 4.93195 6.01626 5.24442 5.79216 5.40577L3.01438 7.40577C2.82348 7.54321 2.56259 7.52901 2.38774 7.37165L0.165522 5.37165C-0.0397331 5.18692 -0.0563723 4.87077 0.128357 4.66552C0.313087 4.46026 0.629232 4.44362 0.834487 4.62835L2.00815 5.68465ZM11.529 7.61587C11.4847 7.88843 11.2278 8.07341 10.9552 8.02904L7.5768 7.47907C7.34463 7.44127 7.17019 7.24675 7.15783 7.01184L7.0007 4.02628C6.98618 3.75052 7.19797 3.5152 7.47373 3.50069C7.74949 3.48618 7.9848 3.69796 7.99931 3.97372L8.13527 6.55681L11.1159 7.04203C11.3884 7.0864 11.5734 7.34332 11.529 7.61587Z"
				fill="#F1FE54"
			/>
		</svg>
	);
};

export default PendingIcon;
